<template>
    <div class="scrollbox">
        <div class="scrollDiv" id="scrollDiv">
            <ul>
                <li v-for="(item,index) in noticeData" :key="index" >{{item.title}}</li>
            </ul>
        </div>
        <i class="icon-notice scrollicon"></i>
        <div class="scrolltit"><div class="updown" id="but_down"></div><div class="updown" id="but_up"></div></div>
        <div class="publish-more">查看详情</div>
    </div>
</template>

<script>
import plugin from '@/plugins/jQextend'
export default {
    data() {
        return {
            noticeData:[
                {
                    title:'梅岭餐馆未清洗严重警告，请进行督办1',
                    content:'1111122222222222222',
                },
                {
                    title:'梅岭餐馆未清洗严重警告，请进行督办2',
                    content:'1111122222222222222',
                },
                {
                    title:'梅岭餐馆未清洗严重警告，请进行督办3',
                    content:'1111122222222222222',
                },
                {
                    title:'梅岭餐馆未清洗严重警告，请进行督办4',
                    content:'1111122222222222222',
                },
            ]
        }
    },
    methods:{

    },
    mounted() {
        $("#scrollDiv").Scroll({
            line:1,
            speed:500,
            timer:5000,
            up:"but_up",
            down:"but_down"
        });
    }

}
</script>

<style lang="less">
.scrollbox {
        position: relative;
        height: 40px;
        margin: 0 auto;
        border: 1px solid #fafad2;
        border-top: none;
        background-color: #fdf5e6;
        padding-left: 55px;
        color: rgb(218, 23, 23);
        font-size: 16px;
        .publish-more{
            position: absolute;
            right: 50px;
            top:0;
            line-height: 40px;
            cursor: pointer;
            font-size: 15px;
            &:hover{
                color:blue;
                i{
                    display: inline-block;
                   transform: translate(2px,0);
                }
            }
        }
        .scrollDiv {
            height: inherit;
            overflow: hidden;
            display:inline-block;
            ul>li {
                height: inherit;
                line-height: 40px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .scrollicon {
            position: absolute;
            top: 3px;
            left: 20px;
            font-size: 28px;
            
        }
        .scrolltit {
            position: absolute;
            top: 3px;
            left: 20px;
            .updown {
                width: 16px;
                height: 16px;
                &#but_up {
                    // background-image: url('../../assets/images/down.png');
                }
                &#but_down {
                    // background-image: url('../../assets/images/up.png');
                }
            }
        } 
    }
</style>




// WEBPACK FOOTER //
// src/components/mainInterface/notice.vue